import { DropDownFieldDefinition } from "@insite/client-framework/Types/FieldDefinition";
import { COMMON, TYPOGRAPHY } from "@store/theme/design";

export enum VerticalGap {
    None = "None",
    Content = "Content",
    Block = "Block",
}

export const getVerticalGapData = (verticalGap: string) => {
    switch (verticalGap) {
        case VerticalGap.None:
            return [];
        case VerticalGap.Content:
            return [TYPOGRAPHY.spacing.base];
        case VerticalGap.Block:
            return COMMON.spacing.content;
        default:
            return null;
    }
};

export const gridVerticalGapFieldOptions = [
    {
        displayName: "None",
        value: VerticalGap.None,
    },
    {
        displayName: "Standard",
        value: VerticalGap.Content,
    },
    {
        displayName: "Large",
        value: VerticalGap.Block,
    },
];

const gridVerticalGapField = {
    displayName: "Stacked column spacing",
    tooltip: "Determines spacing between the columns when they stack on top of each other for smaller devices.",
    editorTemplate: "DropDownField",
    options: gridVerticalGapFieldOptions,
    defaultValue: "",
    fieldType: "General",
} as DropDownFieldDefinition<string>;

export default gridVerticalGapField;
